/**
 * Human-readable Quick Add syntax.
 *
 * Kept next to the parser so the help guide and the recognizer stay in
 * agreement: if a token ships here, it must already parse in quickAddParser.
 */

export type ShortcutTone =
  | 'estimate'
  | 'priority'
  | 'client'
  | 'project'
  | 'energy'
  | 'due'
  | 'schedule';

export interface QuickAddShortcut {
  tone: ShortcutTone;
  /** Token forms shown as chips in the guide. */
  examples: string[];
  /** What the parser turns those tokens into. */
  meaning: string;
}

export const QUICK_ADD_SHORTCUTS: QuickAddShortcut[] = [
  {
    tone: 'estimate',
    examples: ['~45m', '~1.5h', '~90'],
    meaning: 'Estimate (minutes, or hours with h)',
  },
  {
    tone: 'priority',
    examples: ['!1', '!2', '!3', '!4'],
    meaning: 'Priority: urgent → high → normal → low',
  },
  {
    tone: 'client',
    examples: ['@acme', '@"Acme Corp"'],
    meaning: 'Client (prefix match; quote names with spaces)',
  },
  {
    tone: 'project',
    examples: ['#redesign', '#"Q3 Launch"'],
    meaning: 'Project (same matching rules as client)',
  },
  {
    tone: 'due',
    examples: ['tomorrow 2pm', 'fri', 'in 3 days'],
    meaning: 'Due date',
  },
  {
    tone: 'schedule',
    examples: ['>fri 9am', '>tomorrow 2pm', '>2pm'],
    meaning: 'Put it on the planner (a day alone starts at your day start)',
  },
  {
    tone: 'energy',
    examples: ['/high', '/med', '/low'],
    meaning: 'Energy / focus level',
  },
];

export const QUICK_ADD_KEYS = [
  { key: 'C', action: 'Focus capture from anywhere' },
  { key: 'Enter', action: 'Save the task' },
  { key: 'Tab', action: 'Show more fields' },
  { key: 'Esc', action: 'Leave the field (draft kept)' },
] as const;
